import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from '@mui/material';
import { SessionHistoryItem } from '../../services/tutorSessionHistoryService';

interface SessionHistoryListProps {
  sessions: SessionHistoryItem[];
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

function formatDuration(minutes: number | null): string {
  if (minutes === null) return '—';
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

const SessionHistoryList: React.FC<SessionHistoryListProps> = ({ sessions }) => {
  if (sessions.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">No sessions yet.</Typography>
      </Box>
    );
  }

  return (
    <Paper variant="outlined" sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date &amp; Start Time</TableCell>
            <TableCell>End Time</TableCell>
            <TableCell>Duration</TableCell>
            <TableCell>Topics Covered</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sessions.map((s) => (
            <TableRow key={s.sessionId} hover>
              <TableCell>{formatDateTime(s.startedAt)}</TableCell>
              <TableCell>{s.endedAt ? formatDateTime(s.endedAt) : <Typography variant="caption" color="text.secondary">In progress</Typography>}</TableCell>
              <TableCell>{formatDuration(s.durationMinutes)}</TableCell>
              <TableCell>
                {s.topicsVisited.length === 0 ? (
                  <Typography variant="caption" color="text.secondary">None</Typography>
                ) : (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {s.topicsVisited.map((topic, i) => (
                      <Chip key={i} label={topic} size="small" variant="outlined" />
                    ))}
                  </Box>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default SessionHistoryList;
